<template>
  <van-uploader
    v-model="fileList"
    :multiple="maxCount > 1"
    :before-read="beforeRead"
    :after-read="afterRead"
    :before-delete="delUploadImg"
    :max-count="maxCount"
    upload-icon="plus"
  >
  </van-uploader>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/variables'

export default {
  name: 'ImageUploader',
  props: {
    value: {
      type: [String, Array],
      required: false
    },
    maxCount: {
      type: Number,
      required: false,
      default: 1
    },
    prefix: {
      type: [String],
      required: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        if (val instanceof Array) {
          this.initFileList(val.join(','))
        } else {
          this.initFileList(val)
        }
      }
    }
  },
  data () {
    return {
      fileList: [],
      uploadUrl: window._CONFIG.uploadUrl,
      urlView: window._CONFIG.staticDomainUrl,
      headers: {}
    }
  },
  created () {
    const token = Vue.ls.get(ACCESS_TOKEN)
    this.headers = { 'X-Access-Token': token }
  },
  methods: {
    initFileList (paths) {
      if (!paths || paths.length === 0) {
        this.fileList = []
        return
      }
      const fileList = []
      const arr = paths.split(',')
      arr.forEach((item, index) => {
        const url = this.$utils.getFileHttpUrl(item, this.urlView, 'http')
        fileList.push({ url: url })
      })
      this.fileList = fileList
    },
    // 返回布尔值
    beforeRead (file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    // 图片类型检查
    checkFile (file) {
      const format = ['jpg', 'png', 'jpeg']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        this.$toast.fail('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      if (file instanceof Array) {
        file.map((v) => {
          v.status = 'uploading'
          v.message = '上传中...'
          this.uploadImg(v)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadImg(file)
      }
    },

    // 上传
    uploadImg (file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.$http.post(this.uploadUrl, formData, {
        headers: this.headers,
        params: { path: this.prefix }
      }).then((res) => {
        if (res.result) {
          if (file instanceof Array) {
            // 判断是否是数组
            file.map((v, i) => {
              v.status = 'success'
              v.message = ''
              v.url = res.result[i]
            })
          } else {
            file.status = 'success'
            file.message = ''
            file.url = res.result
          }
          this.handlePathChange()
        }
      }).catch((err) => {
        this.$notify({
          type: 'warning',
          message: '上传失败'
        })
        console.log(err)
      })
    },
    // 删除
    delUploadImg (item) {
      this.fileList = this.fileList.filter((v) => v.url !== item.url)
      this.handlePathChange()
    },
    handlePathChange () {
      const uploadFiles = this.fileList
      let path = ''
      if (!uploadFiles || uploadFiles.length === 0) {
        path = ''
      }
      const arr = []
      uploadFiles.forEach((item, index) => {
        arr.push(item.url)
      })
      if (arr.length > 0) {
        path = arr.join(',')
      }
      this.$emit('change', path)
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>
